<template>
  <div class="bg-color-lightblue p-2 rounded mt-5 mb-4">
    <b-row col="12" class="mt-4 justify-content-md-center">
      <b-col sm="12" md="12" lg="12">
        <h2>Lépjen be a személyre szabott tájékoztatásért</h2>
      </b-col>
    </b-row>
    <b-row col="12" class="mt-2 mb-2 justify-content-md-center">
      <b-col sm="12" md="6" lg="4">
        <b-button variant="primary" @click="openLoginModal" class="mt-2 login-button">Bejelentkezés</b-button>
      </b-col>
    </b-row>
    <b-row col="12" class="mt-4 mb-4 justify-content-md-center d-none d-sm-flex">
      <b-col sm="12" md="6" lg="4">
        Még nincs fiókom,
        <router-link :to="{ name: 'Register', query: routeparam }">regisztrálok</router-link>
      </b-col>
    </b-row>
    <b-row col="12" class="mt-4 justify-content-md-center d-sm-none">
      <b-col sm="12">
        <p class="mb-2 mt-3">Ha nem rendelkezik fiókkal, regisztráljon</p>
      </b-col>
    </b-row>
    <b-row col="12" class="mt-2 mb-2 pb-4 justify-content-md-center d-sm-none">
      <b-col sm="12">
        <b-button variant="secondary" @click="openLoginRegistration" class="mt-2 login-button">Regisztráció</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'LoginBanner',
  props: {
    routeparam: Object
  },
  methods: {
    openLoginModal() {
      this.$root.$emit('bv::show::modal', 'login-modal')
    },
    openLoginRegistration() {
      if (this.routeparam) {
        this.$router.push({ path: 'register', query: this.routeparam })
      }
      this.$router.push('/register')
    }
  }
}
</script>

<style scoped>
.login-button {
  width: 270px;
}

@media (max-width: 575px) {
  .login-button {
    width: 100%;
  }
}
</style>
